import Tooltip from "components/ui/Tooltip/Tooltip";
import PropTypes from "prop-types";
import "components/form/ImageUpload/ImageUploadHeading.scss";

function ImageUploadHeading({ title, subtitle, children, tooltipMessage }) {
  return (
    <div className={ 'image-upload-heading' }>
      <div>
        <h3>
          { title } { subtitle && <span className={ 'heading-subtext' }>{ subtitle }</span> }
          { tooltipMessage &&
          <Tooltip message={ tooltipMessage }/> }
        </h3>
      </div>

      { children }
    </div>
  );
}

ImageUploadHeading.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  tooltipMessage: PropTypes.string,
}

export default ImageUploadHeading;
